export {
  PreSubmitSignature,
  preSubmitSignatureConfig,
} from './pre-submit-signature';
